<template>
  <EntitySingle :config="config" :entity.sync="entity" :loaded.sync="loaded">
    <b-card v-if="loaded">
      <b-tabs pills>
        <!-- Tab: Account -->
        <b-tab active>
          <template #title>
            <feather-icon icon="ArchiveIcon" size="16" class="mr-0 mr-sm-50" />
            <span class="d-none d-sm-inline">{{ $t('Information') }}</span>
          </template>
          <EntityEditSection
            :module="config.module"
            :entity.sync="entity"
            :form-fields="infoFields"
            allow-autofocus
          />
        </b-tab>
      </b-tabs>
    </b-card>
  </EntitySingle>
</template>

<script>
import { BTab, BTabs, BCard } from 'bootstrap-vue'

import EntitySingle from '@/layouts/entity/EntitySingle.vue'
import EntityEditSection from '@/layouts/entity/EntityEditSection.vue'

import storeModule from '../promotionStoreModule'

export default {
  components: {
    BTab,
    BTabs,
    BCard,
    EntitySingle,
    EntityEditSection,
  },
  data() {
    return {
      entity: {
        publicPromotion: true,
        enabled: true,
      },
      loaded: false,
      categoryOptions: [],
      sellerOptions: [],
      supplierOptions: [],
    }
  },
  computed: {
    config() {
      return {
        store: storeModule,
        module: 'promotions',
        endpoint: 'promotions',
        route: 'promotions',
        title: {
          single: this.$i18n.t('Promotion'),
          plural: this.$i18n.t('Promotions'),
        },
      }
    },

    infoFields() {
      return [
        {
          id: 'img',
          type: 'image',
          label: this.$t('Featured Image'),
          colSize: 12,
        },
        {
          id: 'title',
          type: 'text',
          label: this.$t('title'),
          required: true,
          colSize: 12,
        },
        {
          id: 'description',
          type: 'quill',
          label: this.$i18n.t('Description'),
          required: true,
          colSize: 12,
        },
        {
          id: 'enabled',
          type: 'checkbox',
          label: this.$t('enabled'),
          rules: '',
          colSize: 2,
        },
        {
          id: 'sendNotification',
          type: 'checkbox',
          label: this.$t('send notification'),
          rules: '',
          colSize: 2,
        },
        {
          id: 'startDate',
          type: 'date',
          label: this.$i18n.t('start date'),
          refMaxDate: 'endDate',
          required: true,
          colSize: 2,
        },
        {
          id: 'endDate',
          type: 'date',
          label: this.$i18n.t('end date'),
          refMinDate: 'startDate',
          required: true,
          colSize: 2,
        },
        {
          id: 'categories',
          object: true,
          type: 'selectmultiple',
          label: this.$t('Categories'),
          options: this.categoryOptions,
          required: false,
          colSize: 4,
        },
        {
          id: 'privatePromotion',
          type: 'checkbox',
          label: this.$t('is private'),
          rules: '',
          colSize: 2,
        },
        {
          id: 'sellers',
          type: 'selectmultiple',
          label: this.$t('Sellers'),
          options: this.sellerOptions,
          colSize: 5,
          dependency: 'privatePromotion',
        },
        {
          id: 'suppliers',
          type: 'selectmultiple',
          label: this.$t('Suppliers'),
          options: this.supplierOptions,
          colSize: 5,
          dependency: 'privatePromotion',
        },
      ]
    },
  },
  mounted() {
    this.$store.dispatch('app-common/fetchPostCategories').then(response => {
      this.categoryOptions = response.data
    })
    this.$store.dispatch('app-common/fetchSellers').then(response => {
      this.sellerOptions = response.data
    })
    this.$store.dispatch('app-common/fetchSuppliers').then(response => {
      this.supplierOptions = response.data
    })
  },
}
</script>
